<!--Banner section starts-->
    <div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
               style="background-image: url(../../assets/graphicbanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top: 60px;">
                    <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Graphic Designing</h1></div>
                    <div>
                        <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">We have an efficient team of graphic designers, logo designers and marketing experts ready to open the doors of opportunities for your business. Be it about graphics design, logo design.
                         
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> 
<!--Banner Section Ends--> 
<!--garphic design definition section start-->
    <div class="uk-section uk-padding" style=" padding-bottom: 0px;">
        <div class="uk-container">
          <h2 class="uk-text-center" style="font-weight: 600;">Grpahic Designing</h2>
          <br>
            <div class="uk-column-1-2@s">
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Graphic Designing is the process of creating visual content to communicate to a larger audience. By applying visual hierarchy and page layout techniques, designers focus on the logic of displaying elements in interactive designs, to optimize the user experience. It is used in creating visual content using elements such as photographs, colors, typography, illustrations and icons. The graphic designing is the art or profession of visual communication that combines images, words, and ideas to convey information to an audience, especially to produce a specific effect. It’s nothing but a way of conveying ideas through visuals and design. Designers distinguish businesses from their competitors in the marketplace through innovative approaches to branding, products and services that express the character of a company and define its relationships with consumers.
                </p>
                <img data-src="assets/gd8.png" width="600" height="600" alt="" uk-img>
            </div>
        </div>
    </div>
    <!--garphic design definition section ends -->

    <!--Benefits of graphic design section start-->

    <h2 class="uk-text-center" style="font-weight: 600;">Benefits of Graphic Designing</h2> 
  
    <div class="uk-section uk-padding">
        <div class="uk-column-1-2@s">
            <img data-src="assets/gd4.png" width="600" height="100" alt="" uk-img>
            <ul class="uk-list uk-list-disc uk-text-medium  uk-text-justify" style="font-size: 18px;">
                <li>Good graphic design cultivates a positive brand identity by reflecting a company’s vision starting from company websites and communications to business cards and staff apparel.</li>
                <li>Graphic design ensures you to maintain a singular identity that draws attention, differentiates your offerings, and can keep your customers coming back to see for new content</li>
                <li>A website with good graphics helps convey the highlights easily and hence convert the visitors in to customers, which increase the business</li>
                <li>Graphics design can help your business successfully transition into this new era of concise, high-speed communication.</li>
                <li>A good graphic design can translate your business into a memorable and trusted brand within the eyes of your audience.</li>
                <li>Graphic design creates a quickly identifiable face for your brand that helps differentiate and stand out against the competition</li>
                <li>Even if you've got a limited marketing budget, it pays to invest in good graphic design as high-quality visuals grab attention at a way higher rate.</li>
            </ul>
                
        </div>
    </div>
    <!--Benefits of graphic design section ends-->
    
        <div class="uk-section  uk-padding" style="background-color: #135796; padding-bottom: 0px;">
            <div class="uk-container uk-container-large ">
                <h1 class="uk-padding-small uk-text-center" style="color: snow; margin-bottom: 0px; font-weight: 600;">Ui/UX Expertise of WebSoulLabs</h1>
                <p class ="uk-text-center" style="color: snow;font-size: 20px;">Creating UI/UX design for your digital products with strategy and design for crafting valuable, memorable and seamless user experience for the client</p>
              
                <div class="uk-grid-match uk-grid-collapse uk-child-width-expand@s  uk-padding uk-text-center"style="padding-top: 20px; padding-bottom: 20px;" uk-grid>
                <div>
                    <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                        <div class="pa">
                            <span class="text-white">
                                <img src="/assets/brain.png" width="50" height="50" alt="svg" style="padding-top: 15px;"></span>
                            <h3 class="uk-text-center" style="color: snow; margin-top: 0px;"><strong>Think</strong></h3>
                     <p  class="uk-text-justify" style="color: snow;">We think similar to our clients and assist them to bring their ideas to life. Together we face the challenges and celebrate the success.
                    </p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                        <div class="pa1">
                            <span class="text-white">
                                <img src="../../assets/web.png" width="50" height="50" alt="svg" style="padding-top: 20px"></span>
                            <h3 class="uk-text-center" style="color: snow;  margin-top: 0px;"><strong>Design</strong></h3>
                            <p class="uk-text-justify" style="color: snow;word-spacing: -3px;">We deliver exceptional designs and transform your insights into memorable ones. Our projects are not only designed using latest technologies but also through a human centred design process.
                            </p>
                                </div>
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                        <div class="pa2">
                            <span class="text-white">
                                <img src="../../assets/tem.png" width="50" height="50" alt="svg" style="padding-top: 15px"></span>
                            <h3 class="uk-text-center" style="color: snow;  margin-top: 0px;"><strong>Measure</strong></h3>
                            <p class="uk-text-justify" style="color: snow;">We verify that each of our web and mobile deliverables are unique and top-notch. We help our clients stay ahead and ensure them continued success
                            </p>
                                </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <div class="uk-section uk-padding" style="padding-bottom: 0px;">
            <div class="uk-container">
                <h2 class="uk-text-center" style="font-weight: 600;">Graphic Design Applications</h2>
                <br>
                <div class="uk-column-1-2@s">
        
                    <h2 style="font-weight: 600;">Design Principles and elements</h2>
                    <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Graphic design plays a critical role in business branding and at the same time, in showcasing the skill-sets. Although branding and design are an inseparable experience, it’s important to understand the fundamentals of graphic design before embarking on new projects. It is the art and science of combining text and graphics to communicate an effective message in the design of websites, logos, graphics, brochures, newsletters, posters, signs, and other types of visual communication.</p>
                        <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">In addition to elements such as images and type, graphic design elements include lines, shapes, texture, value, size, and color. Graphic designers for print and web pages use some or all of these elements to generate effective designs.Designers achieve their goals by combining the elements and principles of graphic design. The goal is usually to attract the viewer's attention and, sometimes, to motivate them to take a specific action.The fundamentals of design are the foundation of every visual medium, from fine art to modern web design. </p>
                    <img data-src="assets/gd5.jpg" width="500" height="500" alt="" uk-img>
        
                </div>
            
                 
                  <h2 class="uk-text-center"  style="font-weight: 600;">Why Choose Us As Your Graphic Designer?</h2>
                  <br>
                   <div class="ws-services uk-grid-column-medium uk-grid-row-large uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m   uk-child-width-1-6@l  uk-text-center uk-grid-match uk-light" uk-grid>
                      <div>
                          <div class="uk-placeholder uk-panel uk-padding" style="padding-top: 20px; padding-bottom: 20px;">
                              
              
                                  <img class=" uk-align-center" src="assets/contract.png" width="65" height="65"
                                      alt="border-circle">
                                  
                             
                              <h4 class="uk-text-center" style="margin-top: 0;">Interactive Graphics</h4>
                             
              
                          </div>
                      </div>
                  
                  <div>
                      <div class="uk-placeholder uk-panel uk-padding" style="padding-top: 20px; padding-bottom: 20px;">
                         
          
                              <img class="uk-align-center" src="assets/pencil (2).png" width="65" height="65"
                                  alt="border-circle">
                              
                           <h4 class="uk-text-center" style="margin-top: 0;">Alluring Layout</h4>
                         
          
                      </div>
                  </div>
            
              <div>
                  <div class="uk-placeholder uk-panel uk-padding" style="padding-top: 20px; padding-bottom: 20px;">
                     
          
                          <img class=" uk-align-center" src="assets/price-tag.png" width="65" height="65"
                              alt="border-circle">
                        
                      
                       <h4 class="uk-text-center" style="margin-top: 0;">Successful Branding </h4>
                     
          
                 
                  </div>
              </div>
              <div>
                 <div class="uk-placeholder uk-panel uk-padding" style="padding-top: 20px; padding-bottom: 20px;">
                 
          
                      <img class="uk-border-circle uk-align-center" src="assets/id.png" width="65" height="65"
                          alt="border-circle">
                     
                 
                   <h4 class="uk-text-center" style="margin-top: 0;">Creative Designer</h4>
                 </div>
              </div>
             <div>
                <div class="uk-placeholder panel uk-padding" style="padding-top: 20px; padding-bottom: 20px;">
                 
          
                    <img class="uk-align-center" src="assets/csshtml.png" width="65" height="65"
                        alt="border-circle">
                   
                
                 <h4 class="uk-text-center" style="margin-top: 0;"> HTML & CSS</h4>
                </div>

              </div>
              <div>
                <div class="uk-placeholder uk-panel uk-padding" style="padding-top: 20px; padding-bottom: 20px;">
                 
          
                    <img class="uk-align-center" src="assets/hot-air-balloon.png" width="65" height="65"
                        alt="border-circle">
                   
                
                 <h4 class="uk-text-center" style="margin-top: 0;"> Corel Draw
                    
                </h4>
                </div>

              </div>
             
               </div>
            </div>
          </div>   
<!--related service section start-->
          <h1 class="uk-text-center" style="margin-bottom: 0px;"><span>Graphic Design Services</span></h1>
          <br>
          <div class="uk-container">
              <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center " uk-grid>
                  <div>
                      <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                                <img class="uk-align-center" src="assets/logodes.jpg" width="110" height="110" alt="">
                                <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Logo Designing</h4>
                        
                            </div>
                        </div>
                        <div>
       
                            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                                <img class="uk-align-center" src="assets/pack.jpg" width="80" height="80" alt="">
                                <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Packaging Design</h4>
                
                           
                             </div>
                       </div>
                       <div>
       
                        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                            <img class="uk-align-center" src="assets/brochure.jpg" width="90" height="90" alt="">
                            <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Brochure Design</h4>
            
                       
                         </div>
                   </div>
                   <div>
       
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                        <img class="uk-align-center" src="assets/flyer.png" width="70" height="70" style=" margin-bottom: 20px;" alt="">
                        <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Flyer Design</h4>
        
                   
                     </div>
               </div>
               <div>
       
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                    <img class="uk-align-center" src="assets/news.jpg" width="90" height="90" alt="">
                    <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Newsletter Designing</h4>
    
               
                 </div>
           </div>
           <br>
       <div>
       
        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
            <img class="uk-align-center" src="assets/poster.jpg" width="42" height="42" alt="">
            <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Poster Design</h4>
       
         </div>
   </div>
   
            </div>
        </div>
        <!--related service section ends-->
<!--Technology stack start-->
<br>
    <h1 class="uk-text-center"><span>Technology Stack</span></h1>
        <br>
           <div class="uk-container">
                <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
                    <div>
                        <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                            <img class="uk-border-circle uk-align-center" src="assets/tech1.jpg" width="90" height="90" alt="border-circle">
                               <h4  style="font-weight: 600;">Logo Maker +</h4>
                       </div>
                   </div>
                    <div>
                        <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                            <img class="uk-border-circle uk-align-center" src="assets/tech2.jpg" width="90" height="90" alt="border-circle">
                               <h4  style="font-weight: 600;">Snip & Sketch</h4>
                       </div>
                   </div>
                   <div>
                        <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                            <img class="uk-border-circle uk-align-center" src="assets/tech3.jpg" width="90" height="90" alt="border-circle">
                               <h4  style="font-weight: 600;">Adobe</h4>
                       </div>
                   </div>
                   <div>           
                       <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                            <img class="uk-border-circle uk-align-center" src="assets/ps.jpg" width="90" height="90" alt="border-circle">
                               <h4  style="font-weight: 600;">PhotoShop</h4>
                       </div>
                   </div>
               </div>
               <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
                   <div>
                        <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                            <img class="uk-border-circle uk-align-center" src="assets/invision.jpg" width="90" height="90" alt="border-circle">
                               <h4  style="font-weight: 600;">Invision</h4>
                       </div>
                   </div>
                   <div>
                       <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                            <img class="uk-border-circle uk-align-center" src="assets/gimp.jpg" width="90" height="90"
                               alt="border-circle">
                               <h4  style="font-weight: 600;">Gimp</h4>
                       </div>
                   </div>
                   <div>
                        <div class="uk-placeholder uk-text-center uk-panel uk-padding">
           
                           <img class="uk-border-circle uk-align-center" src="assets/ink.jpg" width="90" height="90"
                               alt="border-circle">
                               <h4  style="font-weight: 600;">Inkscape</h4>
                       </div>
                   </div>
                   <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                        <img class="uk-border-circle uk-align-center" src="assets/indesgn.jpg" width="90" height="90"
                               alt="border-circle">
                               <h4  style="font-weight: 600;">InDesign</h4>
                       </div>
                   </div>
               </div>
        </div>
<!--technology stack ends-->
           <br>

          